import * as React from 'react';
import ChangeImageModal from '../Wizard/ChangeImageModal';
import { ICrop, IDocument } from '../../infrastructure/interfaces';
import CheckBox from '../CheckBox/CheckBox';
import { TooltipCont } from '../../infrastructure/tooltips';


export interface ICropsEditorFormProps {
  document: IDocument;
  crops: ICrop[];
  toggleCrop(crop: ICrop): any;
  changeCropImage(crop: ICrop, img: string): any;
  className?: string;
}

export interface ICropsEditorFormState {
  showEditModal: boolean;
  editingCrop: ICrop | null;
}

export default class CropsEditorForm extends React.Component<ICropsEditorFormProps, ICropsEditorFormState> {
  constructor(props: ICropsEditorFormProps) {
    super(props);
    this.state = {
      showEditModal: false,
      editingCrop: null,
    };
  }


  onModalClose = () => this.setState({ showEditModal: false, editingCrop: null });
  onModalOpen = (crop: ICrop) => {
    this.setState({ showEditModal: true, editingCrop: crop })
  };

  render() {
    const {
      document,
      crops,
      toggleCrop,
      className,
    } = this.props;
    return (
      <div>
        <div className={className}>
          {crops.map((crop, i) => (
            <div className="stepRow" key={i}>
              <CheckBox
                onClick={() => toggleCrop(crop)}
                checked={!!document.crops.find(c => c.id === crop.id)}
                disabled={!document.crops.find(c => c.id === crop.id) && document.crops.length >= 3}
              />
              <img
                className="cropImage"
                src={!!document.crops.find(c => c.id === crop.id) ? document.crops.find(c => c.id === crop!.id)!.defaultImage : crop.defaultImage}
                alt=""
              />
              <span className="cropTitle">{crop.name}</span>
              <div className="stepOneChangeImage">
                <a href="#" onClick={() => this.onModalOpen(crop)} title={TooltipCont.CHANGE_IMAGE}>
                  Change Image
                </a>
              </div>
            </div>
          ))}
        </div>
        <ChangeImageModal
          show={this.state.showEditModal}
          onClose={this.onModalClose}
          crop={this.state.editingCrop}
          onSave={(img: string) => {
            if (this.state.editingCrop != null) {
              this.props.changeCropImage(this.state.editingCrop, img);
            }
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/CropsEditorForm.tsx